export const NAME_SPACE = '[Blur Modal]';

export default {
	NAME_SPACE
};
